import React from "react";
import styled from "styled-components";
import Flex from 'styled-flex-component';
import Radio from './Radio';

const ModalWrapper = styled(Flex)`
  display: ${({ open }) => (open ? "display" : "none")};
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
  margin: 0 auto;
  background: rgba(0, 0, 0, 0.1);
`;

const ModalTextWrapper = styled(Flex)`
  width: 25vw;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: .5em;
  background: #fff;
  @media(max-width:767px){
    width:300px !important;
  }
`;

const Modal = ({ open, handleModalToggle, handleSubmit, dialogTitle, headings, onChange, selected, onInputChange }) => (

  <ModalWrapper center open={open}>
    <ModalTextWrapper column>
      <Flex justifyBetween>
        <p style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '10px' }} >{dialogTitle}</p>
        <div className="close" onClick={handleModalToggle}>x</div>
      </Flex>
      <div >
        {headings.map((heading, index) => (
          <Radio key={index} id={index} heading={heading} selected={selected} onChange={()=>onChange(heading)}></Radio>
        ))}
        {
          selected === 'Other' && 
          <div>
            <input placeholder="Subject" type="text" onChange={(e)=>onInputChange(e.target.value,'subject')} />
            <textarea placeholder="Message" name="" id="" rows="5" onChange={(e) => onInputChange(e.target.value, 'message')}></textarea>
          </div>
        }
        
        
        <hr/>
        <Flex justifyEnd >
          <p className="cancel" onClick={handleModalToggle}>Cancel</p>
          <p className="submit" onClick={handleSubmit}>Submit</p>
        </Flex>
      </div>
      <style scoped jsx>{`
          .close{
            float:right;
            top:0px;
          }
          hr{
            margin: 10px 0px;
          }
          .cancel{
            margin-right:10px;
            color:gray;
            margin-bottom:0px;
          }
          .submit{
            font-weight:bold;
            margin-bottom:0px;
          }
          .heading{
            margin-bottom: 10px;
            padding: 16px 8px;
            box-shadow: 0 0 2px rgba(0,0,0,0.2);
          }
          .heading:hover{
            background: lightgray;
            cursor: pointer;
          }
          input{
            
          }
          input,textarea{
            padding: 8px;
            width: 100%;
            margin-bottom: 10px;
            margin-top: 5px;
            border-radius: 5px;
            border: 1px solid #9E9E9E;
          }
      `}
      </style>
    </ModalTextWrapper>
  </ModalWrapper>
);

export default Modal;
